import React from "react";

import MDBox from "@/components/atoms/MDBox";
import MDTypography from "@/components/atoms/MDTypography";
import { formatPhoneNumber } from "@/helpers/phone-helpers";
import { WhatsappBspCompletionMessages } from "@/messages/platforms/whatsappBspConnection/whatsappBspCompletionMessages";

interface Props {
  messages: WhatsappBspCompletionMessages;
  phoneNumber?: string;
}

export function Completion({ messages, phoneNumber }: Props) {
  const formattedPhoneNumber = phoneNumber ? formatPhoneNumber(phoneNumber) : "";

  return (
    <MDBox>
      <MDBox width="82%" textAlign="left" mx="auto" my={4}>
        <MDBox mb={1}>
          <MDTypography variant="h5" fontWeight="regular">
            {messages.whatsappBspCompletionText1}
          </MDTypography>
        </MDBox>
        <MDTypography variant="body2" color="text" mb={2}>
          {messages.whatsappBspCompletionText2}
        </MDTypography>

        {phoneNumber && (
          <MDBox mt={2}>
            <MDTypography variant="body2" color="text" fontWeight="bold">
              {messages.whatsappBspCompletionPhoneNumber} {formattedPhoneNumber}
            </MDTypography>
            <MDTypography variant="body2" color="text" fontWeight="bold" mt={1}>
              {messages.whatsappBspCompletionStatus} {messages.whatsappBspCompletionStatusActive}
            </MDTypography>
          </MDBox>
        )}
      </MDBox>
    </MDBox>
  );
}

